import React, { Component } from "react"
import Calculator from "./components/Calculator"
import BmiHeaderSection from "../bmiCalculator/components/shared/bmiHeaderSection/BmiHeaderSection"
import GlCalculatorNewsletter from "./components/GLCalculatorNewsletter"
import addToMailchimp from "gatsby-plugin-mailchimp"
import GlCalculatorIcon from "../../assets/images/icon - food navigator 1.svg"
import GlFeaturesSection from "./components/shared/glFeaturesSection/GlFeaturesSection"
import LocaleContext from "../../context/LocaleContext"
import translate from "../../translation/translator"
import keys from "../../translation/keys"

class CalculatorContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      email: "",
      error: "",
    }
  }

  handleChangeEmail = e => {
    this.setState({ email: e.target.value })
  }

  handleSubmit = async e => {
    e.preventDefault()
    await addToMailchimp(this.state.email).then(data => {
      if (data.result === "success") {
        this.setState({ error: "Успешно изпратен имейл." })
      }
      if (data.msg === "The email you entered is not valid.") {
        this.setState({ error: "Имейлът е невалиден." })
      }
      if (data.msg.includes("<")) {
        this.setState({ error: "Този имейл вече е използван." })
      }
      if (data.msg.includes("Recipient")) {
        this.setState({ error: "Този имейл вече е използван." })
      }
    })
    this.setState({ email: "" })
  }

  render() {
    const { email, error } = this.state
    const { locale } = this.context

    const subText = translate(keys.GL_CALC_SUB_TEXT, locale)
    const text = translate(keys.GL_CALC_TEXT, locale)
    const title = translate(keys.GL_CALC_TITLE, locale)
    return (
      <React.Fragment>
        <BmiHeaderSection
          locale={locale}
          subText={subText}
          text={text}
          icon={GlCalculatorIcon}
          title={title}
        />
        <GlFeaturesSection locale={locale} />
        <Calculator locale={locale} />
        <GlCalculatorNewsletter
          locale={locale}
          handleSubmit={this.handleSubmit}
          error={error}
          email={email}
          handleChangeEmail={this.handleChangeEmail}
        />
      </React.Fragment>
    )
  }
}

CalculatorContainer.contextType = LocaleContext

export default CalculatorContainer
